import React from "react";
import PublicHeader from "../components/homepage/public/PublicHeader";
import PublicFooter from "../components/homepage/public/PublicFooter";

export default function APTutoring() {
  return (
    <div style={{ fontFamily: "'Inter', system-ui, sans-serif", color: "#0f172a" }}>
      <PublicHeader />
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "70px 20px" }}>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 40, margin: 0 }}>
          AP Tutoring
        </h1>
        <p style={{ marginTop: 12, color: "#64748b", lineHeight: 1.9 }}>
          Coming soon. This page will be built after SAT Tutoring is complete.
        </p>

        <div
          style={{
            marginTop: 18,
            border: "1px solid #e2e8f0",
            borderRadius: 18,
            padding: 18,
            background: "#f8fafc",
          }}
        >
          Planned sections: Hero banner • AP subject list • Program structure • Consultation flow • Example curriculum.
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
